<template>
  <div class="benzm-container" >
    <div class="nav-background1">
      <div class="find-header container-wrapper">
        <div class="head-left">
          <!-- <img
            title="点击刷新页面"
            src="../../assets/newHome1/lo-tit.png"
            alt=""
          /> -->
        
        </div>
        <div class="search">
          <el-autocomplete
            class="inline-input"
            v-model="searchText"
            placeholder="请输入OE号/生产编码/配件名称进行搜索"
            @keyup.enter.native="handleSearch"
            clearable
            @clear="handleSearch"
            :hide-loading="true"
            :fetch-suggestions="querySearch"
            @select="handleSearch"
          ></el-autocomplete>
          <div class="seach-btn" @click="handleSearch">
            搜索
          </div>
        </div>
       
      </div>

    </div>
    <div class="container-wrapper">
      <div class="find-body">
        
        <div class="nav-list" >
            <div v-for="(brand,index) in brandList" :brand="brand.name" :key="index"  @click="brandSearch(brand.name)" class="nav-item" :class="{'active':brandName==brand.name}"> 
                <img :src="brand.icon" alt="" srcset="">
            </div> 
        </div>
        <!-- 分类筛选 oesortList-->
        <div class="brand-name">
            <div class="brand-select" @click.stop="displayProduct">
                配件分类 
                <i class="el-icon-arrow-down" v-if="!showProduct"></i>
                <i class="el-icon-arrow-up" v-if="showProduct"></i>
                </div>

            
        </div>
        <div class="brand-cls" v-if="showProduct" >
           
            <!-- <div class="brand-info">    
                <div class="cls-item" v-for="(cls,index) in oesortList" :key="index" @click="toggleCategory(cls)" :class="{'active':oesort==cls}">
                    {{index+1}} {{cls}}
                </div>
            </div> -->
            <div class="coudition-group">
                    <!-- <div class="label">配件分类</div> -->
                    <div class="coudition">
                      <!-- actOesortList -->
                        <div class="coudition-left" v-if="oesortList" :style="{'height':couditionH}">
                            <template v-for="(item,index) of oesortList" >
                                <div  class="coudition-daxiao" :key='"goods_names"+index' v-if="item">
                                    <span  class="item" :class="{'active':actOesortList.includes(item)}" @click="toggleCategory(item)">
                                        {{item}}
                                    </span>
                                </div>
                            </template>
                           
                        </div>
                        <div class="coudition-right">
                            <span @click="toggleCategory('')">
                                取消选中
                            </span>
                        </div>
                    </div>
                </div>
        </div>

        <div class="body-mode goods-list">
            <div class="goods-row" v-for="goods in storeGoodsList" :key="goods.goods_id">
            <div class="goods-card">
                <div class="watermark-text"> {{ $store.state.nickname||$store.state.member_name||"" }}  {{ $store.state.member_id }}</div>
                <div class="goods-left" >
                <div class="watermark-text watermark1"> {{ $store.state.nickname||$store.state.member_name||"" }}  {{ $store.state.member_id }}</div>
                <div class="goods-name">
                    {{goods.goods_name}}
                    <!-- 海报 -->
                    
                    <div class="tag-icon" v-if="goods.isExchange">
                        互
                    </div>
                    <img class="cx-icon" src="../../assets/common/cuxiao.png" v-if="goods.isMcx" alt="" srcset="">
                    <div v-if="goods.goods_commend==71" class="dis-good-tips-small">
                    {{goods.roiZ}} 折
                    </div>
                    <div v-if="goods.goodsPosImg" class="share-btn" @click="shareGoods(goods)">
                    <img src="../../assets/common/分享.jpg" alt="" srcset="">
                    </div>
                    <!-- <div v-if="goods.isStopBuy == 1" class="stop-buy-tag">停采</div> -->
                </div>
                <div class="letf-top" @click.stop="showGoodsInfo(goods)">
                    <el-descriptions title="">
                        <el-descriptions-item label="OE号"> 
                        
                        {{goods.oecode}}
                        <HnwCopy :data="goods.oecode" :left="2" :top="-14"></HnwCopy>
                        </el-descriptions-item>
                        <el-descriptions-item label="生产编码">{{goods.sccode}}
                        <HnwCopy :data="goods.sccode" :left="2" :top="-14"></HnwCopy>
                        </el-descriptions-item>
                        <el-descriptions-item label="配件品牌">
                        <div class="goods-oenaturebrand">
                            {{goods.oenaturebrand}}
                        </div>
                        </el-descriptions-item>
                        <el-descriptions-item label="规格">{{goods.spec}}</el-descriptions-item>
                        <el-descriptions-item label="分类" >
                        
                        {{goods.oesort}}
                        </el-descriptions-item>

                        <el-descriptions-item label="订货价" contentClassName="goods-price">
                        <div class="symbol">￥</div>
                        {{goods.goods_price}}
                        <!-- 8折标识 -->
                        
                        </el-descriptions-item>
                        
                    </el-descriptions>
                </div>
                <el-descriptions title="">
                    <el-descriptions-item label="车型" contentClassName="goods-vehicletype">
                      
                    <div :title="goods.vehicletype">{{goods.vehicletype}}</div>
                    </el-descriptions-item>
                </el-descriptions>
                
                <div class="left-bottom">
                    <el-descriptions title="" v-if="!$store.getters.isVisitor">
                        <el-descriptions-item label="库存" contentClassName="goods-storage">
                        
                        <!-- 停采标签 -->
                        
                        <template v-if="$store.state.store_id=='1780'">
                            
                            <div class="goods-location" > 
                            <div >上海:
                                <span v-if="$store.state.look_inv==1">{{goods.goods_storage}}</span>
                                <span v-else>{{goods.goods_storage>0?"有货":"无货"}}</span> 
                            </div>
                            <div>丹阳:
                                <span v-if="$store.state.look_inv==1">{{goods.goods_stcids}}</span>
                                <span v-else>{{goods.goods_stcids>0?"有货":"无货"}}</span> 
                            </div>
                            </div>
                            <div   class="loca-btn" @click.stop="openAll(goods)" ><span>货位详情</span></div>
                        </template>

                        <div v-else>
                            <span v-if="$store.state.look_inv==1">{{goods.goods_storage}}</span>
                            <span v-else :class="{'disabled-color':goods.goods_storage==0}">{{goods.goods_storage>0?"有货":"无货"}}</span>

                            <span  class="goods-cangTip">{{goods.cangTip}}</span>
                        </div>
                        
                        <div class="del-time red" v-if="goods.delivery_time">
                            预计到货: {{ goods.delivery_time}}
                        </div>
                        </el-descriptions-item>
                    </el-descriptions>
                    <div class="goods-ex-msg" v-if="goods.orderInfo">
                    <div class="buyHis"   @click.stop="readHisList(goods.goods_id)" >
                        您最近一次购买：
                        <span>
                            {{$hnwTools.formatDateTime(goods.orderInfo.add_time,'ymd')}}
                        </span>
                        <span>
                        <!-- {{goods.orderInfo.send_num?goods.orderInfo.send_num:0}} 件 -->
                        {{goods.orderInfo.goods_num?goods.orderInfo.goods_num:0}} 个
                        </span>
                        <span class="readMore" >
                        更多
                        </span>
                    </div>
                    </div>
                </div>
                </div>
                <div class="goods-right">
                <div class="body-item">
                    <div class="goods-picture">
                    <HnwOssImg  :src="goods.goods_image" :preview="true" :width="120" :id="goods.goods_id"></HnwOssImg>
                    </div>
                    
                </div>
                <div class="goods-handle" v-if="!$store.getters.isVisitor">
                    <div class="numAd">                       
                        <el-input-number   v-if="$store.state.zero_buy==1" v-model="goods.goods_num" :min="1"  size="mini"></el-input-number>
                        <el-input-number   v-else  v-model="goods.goods_num"  @change="impueNumChange(goods)" :min="1"  size="mini"></el-input-number>
                        <div class="goods-Fcl-tit" v-if="goods.brand_ratio_price">
                            整箱更优惠
                        </div>
                        <div class="goods-Fcl-tit red" v-if="goods.batch_pur_num_bey">
                            库存不足{{goods.batch_pur_num}}
                        </div>
                    </div>
                    

                    <div class="btn add-btn" :class="{'ygd-btn':goods.goods_storage==0}" @click="joinCart(goods)">
                        {{goods.goods_storage>0?'加入购物车':'加入预购单'}}
                    </div>
                    <div class="addition">
                        <span v-if="goods.cartNum">
                            已添加 {{goods.cartNum||0}} {{goods.oecompany || "个"}}
                            <el-popover
                                placement="left"
                                trigger="click"
                                width="300"
                                popper-class="cart-popover"
                            >
                                <el-table 
                                    :data="goods.cartList || []" 
                                    style="width: 100%" 
                                    :show-header="true"
                                >
                                    <el-table-column 
                                        prop="buyer_name" 
                                        label="操作员" 
                                        align="center"
                                    ></el-table-column>
                                    <el-table-column 
                                        prop="goods_num" 
                                        label="购物车数量" 
                                        align="center"
                                    ></el-table-column>
                                </el-table>
                                <img 
                                    slot="reference" 
                                    src="../../assets/common/cart-list-i.png" 
                                    alt="" 
                                    srcset=""
                                    style="cursor: pointer;width: 10px;"
                                >
                            </el-popover>
                        </span>
                    </div>
                    <el-popover
                    placement="left"
                    width="260"
                    popper-class="pop-replace-list"
                    v-model="goods.replacePopVis"
                    trigger="click">
                    <div class="pop-close"  @click.stop="goods.replacePopVis=false">
                        <i class="el-icon-close"></i>
                    </div>
                    <el-table  :border="false" class="replace-table"  :data="buyStoreList" height="300">
                        <el-table-column width="60" type="index" label="序号"></el-table-column>
                        <el-table-column width="120" property="oecode" label="互换件号">
                        <template slot-scope="scope">
                            <span >{{scope.row.oecode}}</span>
                            <HnwCopy :data="scope.row.oecode" ></HnwCopy>
                        </template>
                        </el-table-column>
                        <el-table-column width="80" property="address" label="操作">
                        <template slot-scope="scope">
                            <span class="show-btn" style="cursor: pointer" v-if="scope.row.goods_id" @click="toSearch(scope.row)">
                            在售
                            </span>
                        
                        </template>
                        </el-table-column>
                    </el-table>
                    
                    <div class="btn replace-btn" slot="reference" @click="showChangeParts(goods)" type="text"  v-if="goods.exchange.length>0">查看互换件</div>
                    
                    </el-popover> 

                </div>

                </div>
            </div>
            </div>

            <div class="pagings"  >             
                <el-pagination
                    background
                    @size-change="query(false)"
                    @current-change="query(false)"
                    :current-page.sync="currentPage"
                    :page-sizes="[ 15,20, 30,40]"
                    :page-size.sync="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="Math.ceil(this.total)">
                </el-pagination>
            </div>
           
           
        </div>
      </div>
    </div>
    <el-dialog title="历史购买记录" :visible.sync="hisVis" center  width="800px">
        <div class="his-list">
            <div class="list-head">
                <div>购买时间</div>
                <div>发货时间</div>
                <div>购买人</div>
                <div class="col-100">价格</div>
                <div class="col-100">购买个数</div>
                <div class="col-100">发货个数</div>
                <div class="col-100">订单状态</div>
                <div class="col-100">订单类型</div>
            </div>
            <div class="list-body">
                <div class="row" v-for="(his,index) in gooodsHisList" :key="index">
                    <div>{{$hnwTools.formatDateTime(his.add_time,'ymd')}}</div>
                    <div>{{$hnwTools.formatDateTime(his.delay_time,'ymd')||"无"}}</div>
                    <div>{{his.member_name}}</div>
                    <div  class="col-100">{{his.goods_price}}</div>
                    
                    <div  class="col-100">{{his.goods_num}}</div>
                    <div  class="col-100">{{his.send_num?his.send_num:'0'}}</div>
                    <div class="col-100">{{$hnwTools.getOrderStateText(his.order_state)}}</div>
                    <div class="col-100">{{his.order_type==7?'线下订单':'平台订单'}}</div> 
                </div>
            </div>
        </div>
    </el-dialog>
    
    <!-- <el-dialog
      title="货位详情"
      :visible.sync="openAllotion"
      width="50%"
    >
      <div class="alltion">
        <div>OE号</div>
        <div>仓库</div>
        <div>货位</div>
        <div>库存</div>
      </div>

      <template v-if="goodsAllotion.dy.list.length>0">
        <div class="alltion">
          <div style="width: 100%;">丹阳</div>
        </div>
        <div class="alltion" v-for="(item) in goodsAllotion.dy.list" :key="item.shelfId">
          <div class="item">{{item.code}}</div>
          <div class="item">{{item.warehouseName}}</div>
          <div class="item">{{item.shelfName}}</div>
          <div class="item">{{item.shelfStockNum}}</div>
        </div>
      </template>
      <template v-if="goodsAllotion.sh.list.length>0">
        <div class="alltion">
          <div style="width: 100%;">上海</div>
        </div>
        <div class="alltion" v-for="(item) in goodsAllotion.sh.list" :key="item.shelfId">
          <div class="item">{{item.code}}</div>
          <div class="item">{{item.warehouseName}}</div>
          <div class="item">{{item.shelfName}}</div>
          <div class="item">{{item.shelfStockNum}}</div>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="openAllotion = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="openAllotion = false">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
  import { export_json_to_excel } from "../../common/utils/Export2Excel"

  export default {
    name: "FindIndex",
    data(){
      return{
        searchText: "",
        storeGoodsList: [], //搜索框数据
        showZero: false,
        currentPage: 1,
        pageSize: 15,
        total: 0, //搜索总条数
        buyStoreList: [],
        gooodsHisList: [],
        hisVis: false,
        brandList: [
          {
            
            icon: require("@/assets/brand/benzm/奔宝博世.png"),
            name: "博世",
          },
          {
            
            icon: require("@/assets/brand/benzm/奔宝卢卡斯.png"),
            name: "卢卡斯",
          },
          {
            
            icon: require("@/assets/brand/benzm/奔宝德尔福.png"),
            name: "德尔福",
          },
          {
            
            icon: require("@/assets/brand/benzm/奔宝采埃孚.png"),
            name: "采埃孚",
          },
          {
            
            icon: require("@/assets/brand/benzm/奔宝斯泰必鲁斯.png"),
            name: "斯泰必鲁斯",
          },
        ], //品牌列表
        brandName: "", //品牌名称
        oesortList: [],
        actOesortList: [],
        showProduct: false, // 控制分类弹窗显示
        oesort: "", // 当前选中的分类
      }
    },
    methods: {
      handleSearch() {
        // if (!this.searchText.trim()) {
        //   this.$warMsg("请输入搜索关键词");
        //   return;
        // }
        
        // 直接触发搜索
        this.query(1);
      },
      async querySearch(str, cb) {
        if (!this.searchText) {
          // ...
          let res = await this.$api.getSearchRecord({
            record_type: 3,
          });
          cb(res);
        } else {
          cb([]);
        }
      },
      brandSearch(brandName){
        if(this.brandName==brandName){
          this.brandName = "";
        }else{
          this.brandName = brandName;
        }
        // this.searchText = brandName;
        this.query(1);
      },
      async query(screen) {
        if (screen) {
          this.currentPage = 1;
        }
        let search = this.searchText || "";
        search = search.trim();

        this.$store.commit("toggleLoding", true);
        
        let searParams = {
          store_page: this.pageSize,
          store_curpage: this.currentPage,
          oenaturebrand: this.brandName,
          search,
          
          oesort: this.actOesortList.join(","),
        };
        if(screen){
          searParams.type = "screen";
        }
        
        let wmRes = await this.$api.getFindBenzmList(searParams);
        try {
            if(wmRes.screen){
              if(wmRes.screen.oesort){
                this.oesortList = wmRes.screen.oesort.map(item=>item.oesort)||[] 
                this.actOesortList = [] // 重置已选分类
              }
            }
            
          } catch (error) {
            console.log("筛选错误 ",error);
            this.oenaturebrandList = []
            this.oesortList = []
          }
          console.log("this.oesortList", this.oesortList);
        
        this.$store.commit("toggleLoding", false);
        let ishhj = false;
        try {
          // ' ' 搜索非品牌并且存在互换件
          if(wmRes.group&&wmRes.group.length>0){
            searParams.search = "";

            wmRes = await this.$api.getFindBenzmList({
                ...searParams,
                oecode: wmRes.group.join(","),
              });
            ishhj = true;
          }else{
            
          }
          wmRes = wmRes.data[0]
          if(ishhj&&wmRes.goods_list&&wmRes.goods_list.length>0){
            wmRes.goods_list.forEach(item=>{
              item.isExchange = true
            })
          }

          
          // 根据参考页面，从wmRes.total获取总数
          if(this.currentPage==1){
            this.total = Number(wmRes.total) || 0
          }
          
          this.handleGoodsList(wmRes);
        } catch (error) {
          console.log("列表错误", error);
          this.storeGoodsList = []
          
          this.total = 0
        }
      },
      async handleGoodsList(res) {
        console.log("res", res);
        let goodsList = [];
        if(res && res.goods_list && Array.isArray(res.goods_list)) {
          goodsList = res.goods_list;
        } else {
          goodsList = [];
        }
        
        let processedOecodes = new Set();
        let expandedGoods = [];
        
        if(goodsList.length > 0) {
          goodsList.forEach(goods => {
            expandedGoods.push(goods);
            
            // 确保价格格式正确
            goods.goods_price = this.$handlePrice(goods);
            this.$set(goods, "goods_num", 1);
            if (!goods.self_storage) {
              goods.self_storage = 0;
            }
            if (!goods.cartNum) {
              goods.cartNum = 0;
            }

            if(goods.exchange) {
              goods.exchange = goods.exchange.filter(item=>item!=goods.oecode)
              this.$set(goods,"replacePopVis",false)
            } else {
              goods.exchange = []
            }

            // if(goods.exchangeResult && goods.exchangeResult.length > 0 && !processedOecodes.has(goods.oecode)){
            //   processedOecodes.add(goods.oecode);
            //   goods.exchangeResult.forEach(exchangeItem => {
            //     let newGoods = { ...exchangeItem };
            //     newGoods.goods_price = this.$handlePrice(newGoods);
            //     this.$set(newGoods, "goods_num", 1);
            //     if (!newGoods.self_storage) {
            //       newGoods.self_storage = 0;
            //     }
            //     if (!newGoods.cartNum) {
            //       newGoods.cartNum = 0;
            //     }
            //     if(newGoods.exchange){
            //       newGoods.exchange = newGoods.exchange.filter(item=>item!=newGoods.oecode)
            //       this.$set(newGoods,"replacePopVis",false)
            //     }else{
            //       newGoods.exchange = []
            //     }
                
            //     this.$set(newGoods, "isExchange", true);
            //     expandedGoods.push(newGoods);
            //   });
            // }
          });
        }
        
        goodsList = expandedGoods;
        console.log("goodsList",goodsList);
        
        this.storeGoodsList = goodsList;
      },
      // 加入购物车
        joinCart(carItem) { 
          // 
          const tidySubPart = async () => {
            let carMessage = {
              goods_id: carItem.goods_id,
              sccode: carItem.sccode,
              oecode: carItem.oecode,
              goods_name: carItem.goods_name,
              goods_price: carItem.goods_price,
              goods_num: carItem.goods_num,
              // goods_storage: carItem.goods_storage,
              goods_storage: carItem.goods_storage,
              store_id: carItem.store_id,
              store_name: carItem.store_name,
              cart_type: "1"
            };

            let res =  await this.$api.joinCart([carMessage]);
            //更新记录中 已添加X件 字段
            if(res){

              // 更新购物车数量
              carItem.cartNum = Number(carItem.cartNum) + Number(carItem.goods_num);
              
              // 初始化cartList数组，如果不存在则创建
              if(!carItem.cartList) {
                carItem.cartList = [];
              }
              
              // 添加或更新购物车列表信息
              const buyerName = this.$store.state.member_name || this.$store.state.nickname || '未知用户';
              const existingCartItem = carItem.cartList.find(
                item => item.buyer_name === buyerName
              );
              console.log("existingCartItem",existingCartItem);
              
              if(existingCartItem) {
                // 如果已存在该买家的信息，则更新数量
                existingCartItem.goods_num = Number(existingCartItem.goods_num) + Number(carItem.goods_num);
              } else {
                // 否则添加新的购物车项
                carItem.cartList.push({
                  buyer_name: buyerName,
                  goods_num: Number(carItem.goods_num)
                });
              }
              
            }
          };

          if (this.$isCompany()) {
            if(carItem.goods_storage>0){
              if(carItem.goods_num + Number(carItem.cartNum) >carItem.goods_storage){
                return this.$store.commit("UpDateState", { invDia: true });
              }else{
                tidySubPart();
              }
            }else{
              // 预购单提示
              if (carItem.goods_storage < 1 && Number(carItem.cartNum) > 0) {
                this.$affMsg("当前预购单已有该商品，是否继续添加?", tidySubPart);
              } else {
                tidySubPart();
              }
            }
            if(carItem.batch_pur_num_bey){

              if (carItem.goods_num > 0 && carItem.batch_pur_num > carItem.goods_num) {
                // 计算超出的数量
                const excessQuantity = carItem.batch_pur_num - carItem.goods_num;
                
                // 获取本地存储的数据
                let localPurData = localStorage.getItem('web-loca-pre-data');
                let purDataArray = [];
                
                // 解析已存在的数据
                if (localPurData) {
                  try {
                    purDataArray = JSON.parse(localPurData);
                  } catch (e) {
                    console.error('解析web-loca-pre-data失败:', e);
                    localStorage.removeItem('web-loca-pre-data');
                    purDataArray = [];
                  }
                }
                
                // 检查是否已存在相同商品（通过goods_id判断）
                const existingItemIndex = purDataArray.findIndex(item => item.goods_id === carItem.goods_id);
                
                if (existingItemIndex === -1) {
                  // 如果不存在相同商品，则添加新的商品信息
                  const excessItem = {
                    ...carItem,
                    goods_num: excessQuantity
                  };
                  purDataArray.push(excessItem);
                  localStorage.setItem('web-loca-pre-data', JSON.stringify(purDataArray));
                }              
                this.$nextTick(() => {
                  carItem.goods_num = carItem.goods_storage;
                });
                return this.$store.commit("UpDateState", { invDia: true });
              } 
            }
            
          }
        },
      handleSizeChange(val) {
        this.pageSize = val;
        this.query(false);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.query(false);
      },
      shortCurpageChange(type) {
        if (type == 1) {
          if (this.currentPage > 1) {
            this.currentPage--;
            this.query(false);
          }
        } else {
          if (this.currentPage < Math.ceil(this.total / this.pageSize)) {
            this.currentPage++;
            this.query(false);
          }
        }
      },
      // 购买记录
        async readHisList(goods_id) {
          
          let res = await this.$api.getGoodsRecord(goods_id);
          this.gooodsHisList = res;
          this.hisVis = true;
        },
       // 查看互换件 
    async showChangeParts(epcPart) {
        if(epcPart.exchange&&epcPart.exchange.length>0){
        let oem =  epcPart.exchange.join(",")
        this.buyStoreList = []
        let res = await this.$api.getBatchSearch({
            oem
        })
        console.log("epcPart",epcPart)
        console.log("res",res)
        
        if(res&&res.length>0){
            let addStr = ''
            res.forEach(goods=>{
            if(!addStr.includes(goods.oecode)){
                this.buyStoreList.push({
                goods_id:goods.goods_id,
                oecode:goods.oecode
                })
                addStr += goods.oecode+","
            }
            })
        }
        epcPart.exchange.forEach(oecode=>{
            let has = this.buyStoreList.some(goods=>goods.oecode==oecode)
            if(!has){
            this.buyStoreList.push({
                oecode
            })
            }
            
        })
        
        epcPart.replacePopVis = true
        }
    
    },
    // 显示货位
        async readStockInfo(data){  
            if(this.$store.state.member_id.indexOf('1780-')!=-1){ 
                let allotion = await this.$http(`${this.$axios.defaults.baseURL.replace("web",'public')}index.php?act=search&op=stockInfo`,{skuId:data.skuId})
                this.goodsAllotion = this.$hnwTools.getAllotion(allotion) 
            }  
            
            this.openAllotion= true
        },
        async openAll(data){  
            // 显示货位
            if(this.$store.state.member_id.includes('1780')){ 
                let allotion = await this.$http(`${this.$axios.defaults.baseURL.replace("web",'public')}index.php?act=search&op=stockInfo`,{skuId:data.skuId})
                console.log("allotion",allotion);
                
                this.goodsAllotion = this.$hnwTools.getAllotion(allotion) 
            }  
          
            this.openAllotion= true
        },
        // 详情
        async showGoodsInfo(goods) {
          goods.preRou = "找件";
          localStorage.setItem("hnw-web-item-data", JSON.stringify(goods));
          this.$router.push("/find/info");
          
        },
        // 分享
        async shareGoods(goods) {
          
          this.posGoodsInfo = goods
          this.$nextTick(()=>{
            this.$refs.sharePoster.sharePoster()
          })
        },
       
        impueNumChange(goods) {
          if (isNaN(goods.goods_num)) {
            this.$nextTick(() => {
              this.$set(goods, "goods_num", 1);
            });
          }else{

            if (goods.goods_storage > 0 && goods.goods_num > goods.goods_storage) {
              // 计算超出的数量
              const excessQuantity = goods.goods_num - goods.goods_storage;
              
              // 获取本地存储的数据
              let localPurData = localStorage.getItem('web-loca-pre-data');
              let purDataArray = [];
              
              // 解析已存在的数据
              if (localPurData) {
                try {
                  purDataArray = JSON.parse(localPurData);
                } catch (e) {
                  console.error('解析web-loca-pre-data失败:', e);
                  purDataArray = [];
                }
              }
              
              // 检查是否已存在相同商品（通过goods_id判断）
              const existingItemIndex = purDataArray.findIndex(item => item.goods_id === goods.goods_id);
              
              if (existingItemIndex === -1) {
                // 如果不存在相同商品，则添加新的商品信息
                const excessItem = {
                  ...goods,
                  goods_num: excessQuantity
                };
                purDataArray.push(excessItem);
                localStorage.setItem('web-loca-pre-data', JSON.stringify(purDataArray));
              }              
              this.$nextTick(() => {
                goods.goods_num = goods.goods_storage;
              });
              return this.$store.commit("UpDateState", { invDia: true });
            }          
          }
        },
      logout() {
        this.$confirm("确定要退出登录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 清除用户信息
          this.$store.commit("resetState");
          // 跳转到登录页
          this.$router.push("/login");
          this.$suMsg("已退出登录");
        });
      },
      // 显示/隐藏分类弹窗
      displayProduct() {
        this.showProduct = !this.showProduct;
      },
      // 选择分类
      toggleCategory(cls) {
        // 如果点击的是当前已选中的分类，则取消选择
        
        if(cls){
          this.actOesortList.push(cls)
        }else{
          this.actOesortList = []
        }
        // this.showProduct = false;
        this.query('');
      },
      // 点击页面其他区域关闭弹窗
      closePop() {
        this.showProduct = false;
      }
    },
    created() {
      // 页面加载时可以初始化一些数据
      this.query(1);
      
      
    }
  }
</script>

<style lang="scss">
  .benzm-container{
    background-color: #f5f5f5;
    padding: 0;
    margin: 0;
    .container-wrapper {
    max-width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
  }
  .brand-name {
    display: flex;
    align-items: center;
    margin-right: 20px;
    padding: 10px 30px;
    .brand-select {
      cursor: pointer;
      display: flex;
      align-items: center;
      margin-right: 10px;
    }
    .brand-checked {
      cursor: pointer;
      font-weight: 500;
    }
  }
  .brand-cls {
   
    // margin-top: 10px;
    padding: 5px 0px;
    .jiao {
      position: absolute;
      top: -8px;
      left: 20px;
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid #fff;
    }
    .brand-info {
      display: flex;
      flex-wrap: wrap;
      .cls-item {
        padding: 5px 10px;
        margin-right:  5px;
        cursor: pointer;
        border-radius: 4px;
        &:hover {
          background: #f5f5f5;
        }
        &.active {
          background: #063376;
          color: #fff;
        }
      }
    }
    .coudition-group {
      display: flex;
      .label {
        min-width: 80px;
        // border-right: 1px solid #ccc;
        // border-bottom: 1px solid #ccc;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .coudition {
        // border-bottom: 1px solid #ccc;
        flex: 1;
        display: flex;
        justify-content: space-between;
        min-height: 28px;
        .active {
          color: #3E84D6;
        }
        .coudition-left {
          display: flex;
          flex-wrap: wrap;
          overflow: auto;
          overflow: hidden;
          padding: 2px 0;
          position: relative;
          flex: 1;

          .coudition-daxiao {
            margin: 5px;
            min-width: 10%;
            border-right: 1px solid #ccc;
            text-align: center;
          }
          // .toggle {
          //   position: absolute;
          //   bottom: -2px;
          //   left: 50%;
          //   i {
          //     cursor: pointer;
          //   }
          // }
        }
        .pabo10 {
          padding-bottom: 10px;
        }
        .item {
          text-align: center;
          line-height: 12px;
          padding: 0 2px;
          min-width: 5%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          border-right: 1px solid #ccc;
          cursor: pointer;
          margin: 5px;
        }
        .item:last-child {
          border-right: none;
        }
        .item:hover {
          color: #3E84D6;
        }
      }

      .coudition-right {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 100px;
        span {
          cursor: pointer;
        }
      }
    }
  }
  .nav-background1 {
    // background-image: url('../../assets/newHome1/nav-back.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    // margin: 10px 0;
    
}
.find-header {
    background: #fff;
    border-bottom: 1px solid #eee;
    // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
   
    
    // border-radius: 8px;
    padding:10px;
    position: relative;
    .head-left{
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
      img{
       height: 30px;
      }
    }
  }
  
  .search {
    display: flex;
    align-items: center;
    width: 500px;
    
    .inline-input {
      width: 354px;
      height: 36px;
      border-radius: 0;
      
      .el-input__inner {
        border-radius: 0;
        height: 36px;
        border: 1px solid #063376;
        
        &:focus {
          border-color: #063376;
        }
      }
    }
    
    .seach-btn {
      width: 100px;
      background: #063376;
      color: #fff;
      border-radius: 0;
      height: 36px;
      position: relative;
      left: -2px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  
  .user-info {
    display: flex;
    align-items: center;
    gap: 15px;
    font-size: 14px;
    color: #666;
  }
  
  .find-body {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    .nav-list{
        width: 100%;
        display: flex;
        justify-content: space-between;
        overflow-x: auto;
        padding: 5px 0;
        background: #fff;
        // margin-bottom: 10px;
        z-index: 100;
        position: relative;
        
        // 吸附样式
        &.sticky {
            position: fixed;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            width: calc(100% - 40px); // 考虑左右padding
            max-width: 1200px; // 限制最大宽度
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
            margin-bottom: 0;
            padding: 10px 0;
        }
        
        .nav-item{
            flex-shrink: 0;
            background-color: #fff;
            padding: 3px 8px;
            text-align: center;
            cursor: pointer;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            margin: 0 3px;
            border-radius: 4px;
            
            img{
                width: 200px;
                // height: 80px;
            }
            &:hover{
                background: #063376;
                color: #fff;
            }
            
        }
        .active{
            // border: 3px solid #063376;
            background: #063376;
            color: #fff;
        }
    }

    > div {
      &:not(:last-child) {
        border-bottom: 1px solid #eee;
      }
      // 1
      // padding: 5px;
      box-sizing: border-box;
    }
    
    
    
    .body-mode {
      .pagings {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 20px;
        background-color: #fff;
        border-top: 1px solid #eee;
        
        .el-pagination {
        //   .btn-prev, .btn-next {
        //     border: 1px solid #dcdfe6;
        //     &:hover {
        //       border-color: #063376;
        //       color: #063376;
        //     }
        //   }
          
          .el-pager {
            li {
            //   border: 1px solid #dcdfe6;
            //   &:hover {
            //     color: #063376;
            //   }
              &.active {
                background-color: #063376;
                border-color: #063376;
              }
            }
          }
        }
      }
    }
    
    .goods-list{
          padding: 0 ;
          .goods-row{
            border-bottom: 1px solid  #E7E7E7;;
            padding: 5px 30px;
            box-sizing: border-box;
            .goods-name{
              font-family: Source Han Sans CN;
              font-weight: 500;
              font-size: 16px;
              color: #333333;
              line-height: 24px;
              padding: 10px 0;
              display: flex;
              align-items: center;

              .tag-icon {
                display: flex;
                align-items: center;
                // transform: scale(0.7);
                justify-content: center;
                width: 20px;
                height: 20px;
                background: $vin-blue;
                color: #fff;
                border-radius: 50%;
                font-size: 12px;
                margin-left: 8px;
              }
              .cx-icon{
                width: 22px;
                margin-left: 8px;
              }
              // 8折标识样式（小一点的版本）
              .dis-good-tips-small {
                margin-left: 8px;
                background: url(../../assets/newHome/折扣.png);
                background-size: 40px 20px;
                width: 40px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                font-size: 12px;
                color: #FFFFFF;
                z-index: 99;
              }
              .dis-good-tips-small-m{
                width: 60px;
                background-size: 60px 20px;
              }
              .share-btn{
                cursor: pointer;
                margin-left: 10px;
                img{
                  width: 20px;
                  position: relative;
                  top: 3px;
                }
              }
            }
            .goods-card{
              display: flex;
              position: relative;
              .watermark-text{
                left: 22px;
                top: 30px;
              }
              .watermark1{
                right: -334px;
                top: 70px;
                // max-width: 600px;
              }
              .el-descriptions{
                .el-descriptions-item__container{
                  align-items: center;
                }
                .el-descriptions-item{
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  font-size: 14px;
                  color: #666666;
                  line-height: 1;
                  // line-height: 24px;
                  // padding-bottom: 0;
                  // height: 30px;
                }
              }
              .goods-left{
                flex: 1;
                position: relative;
                overflow: hidden;
                .letf-top{
                  cursor: pointer;
                  .goods-price{
                    color: #F94F4C;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    font-size: 18px;
                    position: relative;
                  }
                  
                }
                .goods-oenaturebrand{
                  border-radius: 4px;
                  // border: 1px solid #0D347F; 
                  color: #0D347F;
                  font-size: 12px;
                  min-width: 40px;
                  height: 18px;
                  max-width: 140px;
                  overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: normal;
                  line-height: 18px;
                  text-align: center;
                  font-weight: 700;
                  font-size: 18px;
                }
                .goods-storage{
                  span{
                    font-weight: 700;
                    color: #333;
                    font-size: 16px;
                  }
                  .disabled-color{
                    color: #999;
                    font-weight: 400;
                    font-size: 14px;
                  }
                  .goods-cangTip{
                    color: #F94F4C;
                      font-size: 12px;
                      margin-left: 5px;
                      font-weight: bold;
                  }
                  .goods-location{
                    display: flex;
                    
                    >div{
                      display: flex;
                      align-items: center;
                      margin-right: 5px;
                    }
                  }
                  .loca-btn{
                    cursor: pointer;
                    
                    padding: 2px;
                    color: #59a8f8;
                    border: 1px solid #59a8f8;
                    width: 66px;
                    text-align: center;
                  }
                }
                .goods-vehicletype{
                  >div{
                    // display: block;
                    // align-items: center;
                    max-width: 800px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: normal; /* Ensure normal white-space handling */
                    height: 14px;
                  }
                  }
                .left-bottom{
                  position: relative;
                  
                  .goods-ex-msg {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    position: absolute;
                    right: 0;
                    top: 2px;
                    .buyHis {
                      cursor: pointer;
                      text-align: right;
                      padding: 0 5px;
                      color: red;
                      font-size: 12px;
                      > span {
                        margin-right: 10px;
                        align-items: center;
                      }
                      .readMore {
                        cursor: pointer;
                      }
                    }
                    .store-name {
                      padding: 0 5px;
                      color: #3E84D6;
                    }
                  }
                }
              }
              .goods-right{
                display: flex;
                align-items: flex-end;
                justify-content: space-between;
                width: 290px;
                padding-bottom: 10px;
                .body-item{
                  text-align: center;
                  .goods-picture{
                    padding-bottom: 10px;
                  }
                  .numAd{

                  }
                }
                .goods-Fcl-tit{
                  padding-top: 2px;
                  text-align: center;
                }
                .goods-handle{
                  display: flex;
                  flex-direction: column;
                  justify-content: flex-end;
                  align-items: center;
                  .addition {
                    padding-top: 5px;
                    font-size: 14px;
                    color: #999;
                  }
                  .btn{
                    width: 112px;
                    height: 34px;
                    
                    background: rgba(6,51,118,0.1);
                    border-radius: 4px;
                    border: 1px solid #063376;
                    color: #063376;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    font-size: 16px;
                    text-align: center;
                    line-height: 34px;
                    cursor: pointer;
                    margin-top: 10px;
                  }
                  .add-btn{
                    color: #F83431;
                    border: 1px solid #F83431;
                    background: #FEEBEA;
                  }
                  
                  .replace-btn{
                  } 
                  
                }
              }
            }
          }
        }
  }
  }
  
  .his-list {
        .list-head {
        display: flex;
        height: 40px;
        align-items: center;
        background: #eeeeee;
        margin: 10px 0;
        padding: 0 8px;
        > div {
            flex: 1;
            text-align: center;
        }
        .col-100 {
            max-width: 100px;
        }
        }
        .list-body {
        .row {
            display: flex;
            padding: 0 8px;
            > div {
            flex: 1;
            padding: 2px 0;
            border-bottom: 1px solid #eee;
            flex: 1;
            text-align: center;
            line-height: 28px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            }
            .col-100 {
            max-width: 100px;
            }
        }
        }
    }
</style>